import useLivlyUser from "../context/UserProvider";
import { ServiceTypeEnum } from "../types/Building";

export default function useGetService(serviceType: ServiceTypeEnum) {
  const { user } = useLivlyUser();

  return user.building.serviceTypes?.find((s) => s.serviceType === serviceType);
}
